import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

/** Step 1 · motivational card — why activate Voce Pro (gold-bordered). */
const WhyVoicePro = ({ className = '' }) => {
  const { t } = useTranslation('onboarding');
  const bullets = t('why.bullets', { returnObjects: true });
  return (
    <section
      className={`rounded-2xl border border-amber-400/60 bg-card p-4 md:p-5 ${className}`}
      data-testid="wizard-why-voice-pro"
    >
      <h3 className="text-base font-semibold text-foreground md:text-lg">{t('why.title')}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{t('why.intro')}</p>
      <ul className="mt-2 space-y-1 pl-5 text-sm text-foreground/90 list-disc marker:text-amber-400">
        {Array.isArray(bullets) && bullets.map((b) => (
          <li key={b} data-testid="wizard-why-bullet">{b}</li>
        ))}
      </ul>
      <div
        className="mt-4 flex items-start gap-3 rounded-xl border border-amber-500/30 bg-amber-500/10 px-3 py-3"
        data-testid="wizard-why-no-bank"
      >
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-amber-400 text-black">
          <Lock className="h-4 w-4" />
        </span>
        <p className="text-[13px] leading-relaxed text-foreground/90">{t('why.no_bank')}</p>
      </div>
    </section>
  );
};

export default WhyVoicePro;
